import { render, staticRenderFns } from "./SaleInfo.vue?vue&type=template&id=03b6db9b&scoped=true&"
import script from "./SaleInfo.vue?vue&type=script&lang=js&"
export * from "./SaleInfo.vue?vue&type=script&lang=js&"
import style0 from "./SaleInfo.vue?vue&type=style&index=0&id=03b6db9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b6db9b",
  null
  
)

export default component.exports